import React, {FC} from 'react';
import treatment from '../../assets/images/icon-page/treatment.png';


const TreatmentIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'Treatment Icon'}) => {
    return (
        <img
            src={treatment}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default TreatmentIcon;
